export const CRLV_HELP_TITLE = 'Como funciona o CRLV'

export const CRLV_HELP_ITEMS = [
  'É um documento do veículo, não da multa: fica no cadastro do veículo e não depende das consultas de infrações.',
  'Anexo manual: PDF do CRLV digital ou imagem (JPG/PNG) de até 5MB. No PDF o sistema confere se é um CRLV e se a placa é a do veículo; imagens são guardadas sem essa conferência.',
  'Acompanhamento automático: você escolhe os veículos (um, vários ou todos) e ativa o CRLV. O valor por documento segue a tabela por quantidade de placas ativadas (até 100 placas R$ 10; 101 a 500 R$ 8; 501 a 1.000 R$ 6; acima de 1.000 R$ 5) ou o valor negociado no seu contrato. Ele é exibido antes do aceite e cobrado só quando o documento é entregue. Nada é buscado sem a sua ativação.',
  'O acompanhamento acontece ao longo do dia, apenas para veículos com SNE habilitado e credencial válida. Veículos que já têm o CRLV do exercício atual não são buscados de novo.',
  'Do PDF são extraídos exercício, dados do veículo, proprietário e restrições, e é consultado o valor de referência na tabela FIPE.',
  'Situação: Acompanhamento agendado / Em acompanhamento = pedido em andamento; Anexado = CRLV do exercício atual; Vencido = CRLV de exercício anterior; Falhou = o robô não conseguiu (sem cobrança).',
  'Cada novo documento substitui o vigente e o anterior fica no histórico. O download sai como CRLV_placa_renavam_ano.'
]

export const CRLV_HELP_TEXT = [CRLV_HELP_TITLE, ...CRLV_HELP_ITEMS.map(item => `• ${item}`)].join('\n')

export const CRLV_CAPTURE_ACTIVE_STATUSES = ['requested', 'capturing']

const SNE_SERVICE_KEYS = ['snedenatran20', 'snedenatran40']

export function vehicleHasSne(vehicle) {
  if (!vehicle)
    return false
  if (vehicle.sneEnabled)
    return true
  const services = vehicle.services || {}
  return Object.entries(services).some(([name, config]) => {
    const key = String(name).toLowerCase().replace(/[^a-z0-9]/g, '')
    return SNE_SERVICE_KEYS.some(sne => key.endsWith(sne)) && !!(config && config.enable)
  })
}

export function crlvCaptureActive(summary) {
  return !!summary && !!summary.capture && CRLV_CAPTURE_ACTIVE_STATUSES.includes(summary.capture.status)
}

export function crlvCountdown(summary) {
  const days = summary && summary.days_to_expire
  if (days === null || days === undefined)
    return null
  if (days < 0)
    return `venceu há ${Math.abs(days)} dia(s)`
  if (days === 0)
    return 'vence hoje'
  return `vence em ${days} dia(s)`
}

export function crlvBadge(summary) {
  const capture = summary && summary.capture
  if (capture && capture.status === 'requested')
    return { label: 'Acompanhamento agendado', klass: 'badge-info', title: '', countdown: null }
  if (capture && capture.status === 'capturing')
    return { label: 'Em acompanhamento', klass: 'badge-info', title: '', countdown: null }
  if (summary && summary.document_id) {
    const status = summary.licensing_status
    const source = summary.source === 'sne_spider' ? 'Automático' : 'Manual'
    const label = status === 'expired' ? 'Vencido' : status === 'expiring' ? 'A vencer' : status === 'unknown' ? 'Anexado' : 'Válido'
    const klass = status === 'expired' ? 'badge-danger' : status === 'expiring' ? 'badge-warning' : summary.source === 'sne_spider' ? 'badge-success' : 'badge-manual'
    return {
      label: `${label} · ${source}`,
      klass,
      title: summary.exercise_year ? `Exercício ${summary.exercise_year}` : 'Sem exercício identificado',
      countdown: crlvCountdown(summary)
    }
  }
  if (capture && capture.status === 'failed') {
    const userError = capture.failure_kind === 'user'
    const reason = capture.failure_reason || ''
    return {
      label: userError ? 'Falhou · Corrija' : 'Falhou · Sistema',
      klass: userError ? 'badge-user-error' : 'badge-danger',
      title: reason,
      countdown: null,
      failure: reason ? reason.split(/\.\s/)[0] : null,
      userError
    }
  }
  return { label: 'Não anexado', klass: 'badge-secondary', title: '', countdown: null }
}

export const CRLV_FILTER_OPTIONS = [
  { value: 'valid', label: 'CRLV válido' },
  { value: 'expiring', label: 'CRLV a vencer' },
  { value: 'expired', label: 'CRLV vencido' },
  { value: 'manual', label: 'Anexado manualmente' },
  { value: 'captured', label: 'Anexado pelo acompanhamento' },
  { value: 'not_attached', label: 'Sem CRLV' },
  { value: 'eligible', label: 'Elegível para acompanhamento' },
  { value: 'capturing', label: 'Acompanhamento em andamento' },
  { value: 'failed', label: 'Acompanhamento falhou' }
]

export const CRLV_STATS_CARDS = [
  { key: 'valid', label: 'CRLV válidos', filter: 'valid', klass: 'card-valid', icon: 'shield-icon' },
  { key: 'expiring', label: 'A vencer', filter: 'expiring', klass: 'card-expiring', icon: 'clock-icon' },
  { key: 'expired', label: 'Vencidos', filter: 'expired', klass: 'card-expired', icon: 'alert-triangle-icon' },
  { key: 'not_attached', label: 'Sem CRLV', filter: 'not_attached', klass: 'card-missing', icon: 'file-minus-icon' },
  { key: 'capturing', label: 'Em acompanhamento', filter: 'capturing', klass: 'card-capturing', icon: 'refresh-cw-icon' }
]
